var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6923 3.0484C30.5137 3.56538 29.2579 3.90806 27.9486 4.07444C29.2955 3.27025 30.3236 2.00652 30.8069 0.483308C29.5511 1.23204 28.1645 1.7609 26.6869 2.05604C25.4944 0.786366 23.7949 0 21.9409 0C18.3439 0 15.448 2.91965 15.448 6.4989C15.448 7.0139 15.4916 7.5091 15.5985 7.98052C10.197 7.71708 5.4174 5.12821 2.20657 1.1845C1.64602 2.15706 1.31721 3.27025 1.31721 4.46862C1.31721 6.71877 2.47596 8.7134 4.20319 9.86819C3.15932 9.84838 2.13527 9.54533 1.26769 9.06796C1.26769 9.08777 1.26769 9.11352 1.26769 9.13927C1.26769 12.2966 3.51982 14.9192 6.47314 15.5233C5.94428 15.6679 5.36788 15.7372 4.76969 15.7372C4.35372 15.7372 3.9338 15.7134 3.53963 15.6263C4.38145 18.1993 6.77026 20.0909 9.61068 20.1523C7.40014 21.8816 4.5934 22.9234 1.5549 22.9234C1.02208 22.9234 0.511038 22.8997 0 22.8343C2.87805 24.6903 6.28893 25.75 9.96722 25.75C21.9231 25.75 28.4597 15.8462 28.4597 7.2615C28.4597 6.97429 28.4497 6.69698 28.4359 6.42165C29.7254 5.50654 30.8088 4.36363 31.6923 3.0484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.65de5e534b3ca0aa668bb225a34f81ad.svg";
export { ForwardRef as ReactComponent };